import { GoHighLevelIntegrationFields } from '../GoHighLevelIntegrationFields/GoHighLevelIntegrationFields'
import { WixIntegrationFields } from '../WixIntegrationFields/WixIntegrationFields'
import {
  BlogMetadataIntegrationState,
  BlogMetadataIntegrationHandlers,
} from '../../../hooks/useBlogMetadataIntegration'

interface BlogMetadataIntegrationSectionProps {
  integrationState: BlogMetadataIntegrationState
  handlers: BlogMetadataIntegrationHandlers
  isPostPublished: boolean
}

export const BlogMetadataIntegrationSection: React.FC<BlogMetadataIntegrationSectionProps> = ({
  integrationState,
  handlers,
  isPostPublished,
}) => {
  const { isGoHighLevelIntegration, isWixIntegration } = integrationState

  if (isGoHighLevelIntegration) {
    return (
      <GoHighLevelIntegrationFields
        integrationState={integrationState}
        handlers={handlers}
        isPostPublished={isPostPublished}
      />
    )
  }

  if (isWixIntegration) {
    return (
      <WixIntegrationFields integrationState={integrationState} handlers={handlers} isPostPublished={isPostPublished} />
    )
  }

  return null
}
